import { useState, useCallback, useEffect } from 'react';
import { api, ApiError } from '../utils/apiClient';

export interface AccountUsageData {
  projects: number;
  tier: string;
  limits: {
    projects: number;
    endpointsPerProject: number;
    requestsPerDay: number;
    logRetentionDays: number;
    globalVariables: number;
  };
}

interface UseAccountUsageReturn {
  usage: AccountUsageData | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useAccountUsage(): UseAccountUsageReturn {
  const [usage, setUsage] = useState<AccountUsageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchUsage = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await api.get<AccountUsageData>('/api/usage');
      setUsage(data);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Failed to fetch usage');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsage();
  }, [fetchUsage]);

  return { usage, loading, error, refetch: fetchUsage };
}
